import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledGridBody = styled(Box)(({ theme }) => ({
  '& * .CfTableRow-row:hover': {
    backgroundColor: theme.palette.coolGrey[100] + ' !important',
  },
  '& * CfTableRow-footerHover + .CfTableRow-footer': {
    backgroundColor: theme.palette.coolGrey[100],
  },
  '& * .CfTableRow-row:hover + .CfTableRow-footer': {
    backgroundColor: theme.palette.coolGrey[100],
  },
  '& * .CfTableRow-row:focus-within': {
    backgroundColor: theme.palette.coolGrey[100],
  },
  '& * .CfTableRow-row.CfTableRow-footerFocus': {
    backgroundColor: theme.palette.coolGrey[100],
  },

  '& > .CfTableRow-row:first-of-type': {
    borderTop: 'none',
  },

  '& * .CfTableRow-footer:hover': {
    backgroundColor: theme.palette.coolGrey[100] + ' !important',
  },
  '& * .CfTableRow-footerHover': {
    backgroundColor: theme.palette.coolGrey[100] + ' !important',
  },
  '& * .row:hover + .row-footer > .CfTableRow-footer ': {
    backgroundColor: theme.palette.coolGrey[100] + ' !important',
  },

  '& * .CfTableRow-footer:focus-within': {
    backgroundColor: theme.palette.coolGrey[100] + ' !important',
  },
  '& * .CfTableRow-footerFocus': {
    backgroundColor: theme.palette.coolGrey[100],
  },
  '& * .row:focus-within + .row-footer > .CfTableRow-footer ': {
    backgroundColor: theme.palette.coolGrey[100] + ' !important',
  },
}));
